<template>
    <div id="app">
        <v-app id="inspire">
            <v-card v-model="show" color="#FFFF99">
                <v-card-title>
                    Cargar Consumo de Combustible
                </v-card-title>
                <v-card-text class="pt-2">
                    <v-row dense>
                        <!-- <v-col cols="8" sm="8" md="8">
                <v-text-field dense v-model="filtroproducto" @change="cargarproducto(filtroproducto)"
                  label="Ingresar Ubicación">
                </v-text-field>
              </v-col> -->
                        <v-col cols="12" sm="6" md="8">
                            <v-select item-color="green" color="green darken-2" dense v-model="equipo"
                                :items="listadoequipo" label="Equipo" item-text="nombre"
                                item-value="codgral"></v-select>
                        </v-col>
                        <v-col cols="2" sm="2" md="1">
                            <v-dialog v-model="dialogcamara" width="500">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn color="red lighten-2" dark v-bind="attrs" v-on="on" @click="showCamera('1')">
                                        Scan
                                        <v-icon dark right>
                                            mdi-camera
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <div class="container">
                                    <v-form ref="form" v-model="validcamara" :lazy-validation="lazycamara">
                                        <v-card elevation="24" max-width="400" class="mx-auto" color="#00BB2D" dark
                                            raised>
                                            <v-card-title class="headline layout justify-center">Lector de Código QR
                                                <p class="error">{{ error }}</p>

                                                <p class="decode-result">
                                                    Último resultado: <b></b>
                                                </p>
                                            </v-card-title>
                                            <v-container>
                                                <v-row dense>
                                                    <v-col cols="12">
                                                        <StreamBarcodeReader v-if="isview" @close="onClosed"
                                                            @decode="onDecode" @loaded="onLoaded">
                                                        </StreamBarcodeReader>
                                                    </v-col>
                                                </v-row>
                                            </v-container>
                                        </v-card>
                                    </v-form>
                                </div>
                            </v-dialog>
                        </v-col>
                    </v-row>
                    <!-- <v-row dense>
                        <v-col cols="12" sm="4" md="2">
                            
                        </v-col>
                        <v-col cols="12" sm="4" md="2">
                            <h6>Fecha: {{ comprob.fecha }}</h6>
                        </v-col>
                        <v-col cols="12" sm="4" md="2">
                            <h6>Importe: {{ comprob.importe }}</h6>
                        </v-col>
                        <v-col cols="12" sm="4" md="2">
                            <h6>Comprobante: {{ comprob.nroCmp }}</h6>
                        </v-col>
                        <v-col cols="12" sm="4" md="2">
                            <h6>CUIT: {{ comprob.cuit }}</h6>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                            <h6>Responsable: </h6>
                        </v-col>
                    </v-row> -->

                </v-card-text>
            </v-card>
            <v-card>
                <v-data-table dense :headers="headers" :items="comprobantes" locale="es-ar" class="elevation-1"
                    :items-per-page="100" :footer-props="{
                        itemsPerPageText: 'Componentes por página',
                    }">
                    <template v-slot:item.codgral="{ item }">
                        <v-select item-color="green" color="green darken-2" dense v-model="item.codgral"
                            :items="listadoequipo" item-text="nombre" item-value="codgral"></v-select>
                    </template>

                    <template v-slot:item.km="{ item }">
                        <v-text-field dense v-model="item.km"></v-text-field>
                    </template>
                    <template v-slot:item.litros="{ item }">
                        <v-text-field dense v-model="item.litros"></v-text-field>
                    </template>
                    <template v-slot:item.fecha="{ item }">
                        <!-- <div class="right-input"> -->
                        <v-text-field dense v-model="item.fecha"></v-text-field>
                        <!-- </div> -->
                    </template>
                    <template v-slot:item.importe="{ item }">
                        <!-- <div class="right-input"> -->
                        <v-text-field dense v-model="item.importe"></v-text-field>
                        <!-- </div> -->
                    </template>
                    <template v-slot:item.ticket="{ item }">
                        <!-- <div class="right-input"> -->
                        <v-text-field dense v-model="item.ticket"></v-text-field>
                        <!-- </div> -->
                    </template>
                    <template v-slot:item.nrocomp="{ item }">
                        <!-- <div class="right-input"> -->
                        <v-text-field dense v-model="item.nrocomp"></v-text-field>
                        <!-- </div> -->
                    </template>
                    <template v-slot:item.cuit="{ item }">
                        <!-- <div class="right-input"> -->
                        <v-text-field dense v-model="item.cuit"></v-text-field>
                        <!-- </div> -->
                    </template>
                    <template v-slot:item.responsable="{ item }">
                        <!-- <div class="right-input"> -->
                        <v-text-field dense v-model="item.responsable"></v-text-field>
                        <!-- </div> -->
                    </template><template v-slot:item.observ="{ item }">
                        <!-- <div class="right-input"> -->
                        <v-text-field dense v-model="item.observ"></v-text-field>
                        <!-- </div> -->
                    </template>

                </v-data-table>
                <v-btn dense class="mx-2" dark small color="orange" @click="addRow('I')">Agregar fila</v-btn>
            </v-card>

            <v-card color="blue" dark tile>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="success" @click.stop="guardar">Guardar</v-btn>
                    <!-- 
              <v-btn color="error" @click.stop="show = false">Salir</v-btn> -->
                </v-card-actions>
            </v-card>
        </v-app>
    </div>
</template>
<style scoped>
::v-deep .v-data-table__empty-wrapper {
    display: none;
}
</style>
<style lang="css" scoped>
::v-deep .v-text-field input {
    font-size: 10pt;
}

::v-deep .v-select {
    font-size: 10pt;
}
</style>
<script>
import moment from "moment";
import axios from "../../../axios-auth";
import { StreamBarcodeReader } from "vue-barcode-reader";
export default {
    components: { StreamBarcodeReader },
    data: (vm) => ({
        validcamara: false,
        lazycamara: false,
        dialogcamara: false,
        result: "",
        error: "",
        isview: false,
        filtrar: "",
        editedItem: {},
        editedIndex: -1,
        comp: [],
        comprobantes: [
            { codgral: "", km: "", litros: "", fecha: "", importe: "", ticket: "", nrocomp: "", cuit: "", responsable: "", observ: "" },
            { codgral: "", km: "", litros: "", fecha: "", importe: "", ticket: "", nrocomp: "", cuit: "", responsable: "", observ: "" },
            { codgral: "", km: "", litros: "", fecha: "", importe: "", ticket: "", nrocomp: "", cuit: "", responsable: "", observ: "" },
            { codgral: "", km: "", litros: "", fecha: "", importe: "", ticket: "", nrocomp: "", cuit: "", responsable: "", observ: "" },
            { codgral: "", km: "", litros: "", fecha: "", importe: "", ticket: "", nrocomp: "", cuit: "", responsable: "", observ: "" },
            { codgral: "", km: "", litros: "", fecha: "", importe: "", ticket: "", nrocomp: "", cuit: "", responsable: "", observ: "" },
            { codgral: "", km: "", litros: "", fecha: "", importe: "", ticket: "", nrocomp: "", cuit: "", responsable: "", observ: "" },
            { codgral: "", km: "", litros: "", fecha: "", importe: "", ticket: "", nrocomp: "", cuit: "", responsable: "", observ: "" },
        ],

        equipo: "",
        listadoequipo: [],
        importe: "",
        fecha: "",
        ptoVta: "",
        nroCmp: "",
        cuit: "",
        nombre: "",
        decodedStr: null,
        stringseparado: [],
        comprob: [],
        dialog: false,
        dialogDelete: false,
        headers: [
            {
                text: "Vehículo",
                align: "start",
                sortable: false,
                value: "codgral",
                width: "20%"
            },
            { text: "Kilometraje", value: "km", width: "6%" },
            { text: "Litros", value: "litros", width: "6%" },
            { text: "Fecha", value: "fecha", width: "9%" },
            { text: "Importe", value: "importe", width: "7%" },
            { text: "N° Ticket", value: "ticket", width: "7%" },
            { text: "N° Factura", value: "nrocomp", width: "7%" },
            { text: "Cuit", value: "cuit", width: "10%" },
            { text: "Responsable", value: "responsable", width: "13%" },
            { text: "Observaciones", value: "observ", width: "15%" },
        ],
        valid: false,
        lazy: false,
        mensaje: "",
    }),
    // watch: {
    //   dialog(val) {
    //     val || this.close();
    //     console.log(this.valid);
    //   },
    //   dialogDelete(val) {
    //     val || this.closeDelete();
    //   },
    // },
    computed: {
        //   formTitle() {
        //     return this.editedIndex === -1 ? "Nuevo Componente" : "Editar Componente";
        //   },
        show: {
            get() {
                this.cargarEquipo();
                this.cargarcom();
                //this.$store.state.sector = "Inspeccion";
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.$refs.form.resetValidation();
                    //this.vaciarModels();
                    this.$emit("close");
                }
            },
        },
    },
    methods: {
        scrollToTop() {
            window.scrollTo(0, 0);
        },
        onClosed() {
            console.log("onClosed");
            this.isview = false;
        },
        showCamera(flag) {
            if (flag == "1") {
                this.filtrar = "1";
            }
            if (flag == "2") {
                this.filtrar = "2";
            }
            return (this.isview = !this.isview);
        },
        onDecode(result) {
            if (this.filtrar == "1") {
                console.log("FLAG1");
                this.filtroproducto = result;
                this.cargarcomprobante(result);
                this.onClosed;
            }
            // if (this.filtrar == "2") {
            //   console.log("FLAG2");
            //   this.cargarcomponente(result);
            //   this.onClosed;
            // }
            this.isview = false;
            this.dialogcamara = false;
        },
        onLoaded() {
            console.log("load");
        },
        cargarEquipo() {
            let self = this;
            axios
                .get("/SSGG/CargarVehiculo?", {
                    params: {
                    },
                })
                .then((response) => {
                    self.listadoequipo = response.data;
                })
                .catch((error) => {
                    self.listadoequipo = "";
                    console.log(error);
                });
        },

        addRow(flag) {
            this.comprobantes.push({ codgral: "", fecha: "", km: "", litros: "", importe: "", nrocomp: "", resp: "", observ: "" })

        },

        cargarcomprobante(resultado) {
            this.decodedStr = atob(resultado.replace("https://www.afip.gob.ar/fe/qr/?p=", ""));
            this.comprob = JSON.parse(this.decodedStr)
            this.comprobantes.unshift({ codgral: this.equipo, fecha: moment(this.comprob.fecha, "YYYY-MM-DD").format("DD/MM/YYYY"), importe: this.comprob.importe, ticket: "", nrocomp: this.comprob.nroCmp, cuit: this.comprob.cuit, responsable: "", observ: "" })

        },
        cargarcom() {
            var deco = "eyJ2ZXIiOiAxLCJmZWNoYSI6ICIyMDIzLTExLTAxIiwiY3VpdCI6ICIzMDY4OTc2NDU5OSIsInB0b1Z0YSI6IDIyNTUsInRpcG9DbXAiOiA4MiwibnJvQ21wIjogMTA1OTc4LCJpbXBvcnRlIjogOTI0MTAwLCJtb25lZGEiOiAiUEVTIiwiY3R6IjogMSwidGlwb0NvZEF1dCI6ICJFIiwiY29kQXV0IjogIjczNDQ5NjA3NTYzMTMzIn0="
            this.decodedStr = atob(deco)
            console.log("json " + this.decodedStr[0]["fecha"])
            this.comprob = JSON.parse(this.decodedStr)
            // console.log("JSON " + this.comprob.fecha + "otro " + this.comprob["fecha"])
            // this.stringseparado = this.decodedStr.split(",")
            // //this.fecha = this.stringseparado[1].substring(10, 20)
            // this.cuit = this.stringseparado[2].substring(9, 20)
            // this.nroCmp = this.stringseparado[3].substring(10) + "-" + this.stringseparado[5].substring(10)
            // this.importe = this.stringseparado[6].substring(10)
            // this.fecha = this.decodedStr["fecha"]
            // console.log("FECHA " + this.fecha)
        },
        showAlert(alertInfo) {
            alertInfo.vm.$swal.fire({
                icon: alertInfo.icon,
                title: alertInfo.title,
                showConfirmButton: false,
                background: "#ececec",
                timer: alertInfo.timer,
            });
        },

        guardar() {
            this.$swal({
                title: "Guardar Carga Combustible",
                text: "¿Desea guardar los datos?",
                icon: "success",
                type: "success",
                showCancelButton: true,
                background: "#ececec",
                confirmButtonText: "Si",
                cancelButtonText: "No",
                showCloseButton: true,
                showLoaderOnConfirm: true,
            }).then((result) => {
                if (result.value) {
                    this.comprobantes.forEach((element) => {
                        if (element.codgral != "" && element.codgral != null) {
                            console.log("item" + element.codgral)
                            this.comp.push({
                                codgral: element.codgral,
                                km: element.km,
                                litros: element.litros,
                                fecha: element.fecha,
                                importe: element.importe,
                                comprobante: element.nrocomp,
                                ticket: element.ticket,
                                cuit: element.cuit,
                                responsable: element.responsable,
                                observ: element.observ,
                            });
                            console.log("comp" + this.comp)
                        }
                    });

                    let self = this;

                    axios
                        .post("/SSGG/GuardarCombustible", this.comp)
                        .then((response) => {

                            // self.$refs.form.resetValidation();
                            self.vaciarModels();
                            self.showAlert({
                                icon: "success",
                                title: "Carga de combustible guardada con éxito",
                                timer: "3000",
                                vm: self,
                            });
                            self.$emit("close");
                        })
                        .catch({});
                } else {
                    //this.$swal('Cancelled', 'Your file is still intact', 'info')
                }
            });
        },

        vaciarModels() {
            this.comp = [];
            this.comprobantes = [
                { codgral: "", km: "", litros: "", fecha: "", importe: "", ticket: "", nrocomp: "", cuit: "", responsable: "", observ: "" },
                { codgral: "", km: "", litros: "", fecha: "", importe: "", ticket: "", nrocomp: "", cuit: "", responsable: "", observ: "" },
                { codgral: "", km: "", litros: "", fecha: "", importe: "", ticket: "", nrocomp: "", cuit: "", responsable: "", observ: "" },
                { codgral: "", km: "", litros: "", fecha: "", importe: "", ticket: "", nrocomp: "", cuit: "", responsable: "", observ: "" },
                { codgral: "", km: "", litros: "", fecha: "", importe: "", ticket: "", nrocomp: "", cuit: "", responsable: "", observ: "" },
                { codgral: "", km: "", litros: "", fecha: "", importe: "", ticket: "", nrocomp: "", cuit: "", responsable: "", observ: "" },
                { codgral: "", km: "", litros: "", fecha: "", importe: "", ticket: "", nrocomp: "", cuit: "", responsable: "", observ: "" },
                { codgral: "", km: "", litros: "", fecha: "", importe: "", ticket: "", nrocomp: "", cuit: "", responsable: "", observ: "" },
            ];
            //this.comprobante = [];
        },

    },
};
</script>